__turbopack_context__.v({
  "card": "_5BMZcq_card",
  "cardBody": "_5BMZcq_cardBody",
  "cardDescription": "_5BMZcq_cardDescription",
  "cardTitle": "_5BMZcq_cardTitle",
  "cards": "_5BMZcq_cards",
  "darkSection": "_5BMZcq_darkSection",
  "headerColumn": "_5BMZcq_headerColumn",
  "layout": "_5BMZcq_layout",
  "learnMoreButton": "_5BMZcq_learnMoreButton",
  "shell": "_5BMZcq_shell",
  "stepNumber": "_5BMZcq_stepNumber",
  "stickyHeader": "_5BMZcq_stickyHeader",
  "subtitle": "_5BMZcq_subtitle",
  "textGroup": "_5BMZcq_textGroup",
  "thumb": "_5BMZcq_thumb",
  "title": "_5BMZcq_title",
  "viewPlansCTA": "_5BMZcq_viewPlansCTA",
});
